export var AuditAction;
(function (AuditAction) {
    // Integrations
    AuditAction["INTEGRATION_CONNECTED"] = "integration.connected";
    AuditAction["INTEGRATION_DISCONNECTED"] = "integration.disconnected";
    AuditAction["MCP_CONNECTED"] = "mcp.connected";
    AuditAction["MCP_REVOKED"] = "mcp.revoked";
    AuditAction["MCP_TOOL_CALLED"] = "mcp.tool_called";
    AuditAction["MCP_RESOURCE_READ"] = "mcp.resource_read";
    // Connector credential lifecycle
    AuditAction["CONNECTOR_PROVISIONING_TOKEN_ISSUED"] = "connector.provisioning_token_issued";
    AuditAction["CONNECTOR_REVOKED"] = "connector.revoked";
    // Organization / RBAC / invites
    AuditAction["ORG_MEMBER_ADDED"] = "org.member_added";
    AuditAction["ORG_MEMBER_ROLE_CHANGED"] = "org.member_role_changed";
    AuditAction["ORG_MEMBER_REMOVED"] = "org.member_removed";
    AuditAction["ORG_MEMBER_LEFT"] = "org.member_left";
    AuditAction["ORG_INVITE_CREATED"] = "org.invite_created";
    AuditAction["ORG_INVITE_ACCEPTED"] = "org.invite_accepted";
    AuditAction["ORG_JOIN_REQUEST_APPROVED"] = "org.join_request_approved";
    AuditAction["ORG_JOIN_REQUEST_REJECTED"] = "org.join_request_rejected";
    // Workspace membership / invites / lifecycle
    AuditAction["WORKSPACE_MEMBER_ADDED"] = "workspace.member_added";
    AuditAction["WORKSPACE_MEMBER_ROLE_CHANGED"] = "workspace.member_role_changed";
    AuditAction["WORKSPACE_MEMBER_REMOVED"] = "workspace.member_removed";
    AuditAction["WORKSPACE_MEMBER_LEFT"] = "workspace.member_left";
    AuditAction["WORKSPACE_INVITE_CREATED"] = "workspace.invite_created";
    AuditAction["WORKSPACE_INVITE_ACCEPTED"] = "workspace.invite_accepted";
    AuditAction["WORKSPACE_DELETED"] = "workspace.deleted";
    // Documents
    AuditAction["DOCUMENT_CONTENT_ACCESSED"] = "document.content_accessed";
    AuditAction["DOCUMENT_DELETED"] = "document.deleted";
    // Account / organization deletion
    AuditAction["ACCOUNT_DELETED"] = "account.deleted";
    AuditAction["ORGANIZATION_DELETED"] = "organization.deleted";
    // Agent writes (external mutations)
    AuditAction["AGENT_JIRA_ISSUE_CREATED"] = "agent.jira.issue_created";
    AuditAction["AGENT_JIRA_SPRINT_CREATED"] = "agent.jira.sprint_created";
    AuditAction["AGENT_JIRA_ISSUES_MOVED_TO_SPRINT"] = "agent.jira.issues_moved_to_sprint";
    AuditAction["AGENT_JIRA_ISSUE_UPDATED"] = "agent.jira.issue_updated";
    AuditAction["AGENT_JIRA_ISSUE_TRANSITIONED"] = "agent.jira.issue_transitioned";
    AuditAction["AGENT_JIRA_ISSUE_ASSIGNED"] = "agent.jira.issue_assigned";
    AuditAction["AGENT_JIRA_COMMENT_ADDED"] = "agent.jira.comment_added";
    AuditAction["AGENT_JIRA_ISSUES_LINKED"] = "agent.jira.issues_linked";
    AuditAction["AGENT_JIRA_EPIC_DECOMPOSED"] = "agent.jira.epic_decomposed";
    AuditAction["AGENT_CONFLUENCE_PAGE_CREATED"] = "agent.confluence.page_created";
    AuditAction["AGENT_CONFLUENCE_PAGE_UPDATED"] = "agent.confluence.page_updated";
    AuditAction["AGENT_GITHUB_ISSUE_CREATED"] = "agent.github.issue_created";
    AuditAction["AGENT_GITHUB_ISSUE_UPDATED"] = "agent.github.issue_updated";
    AuditAction["AGENT_GITHUB_ISSUE_TRANSITIONED"] = "agent.github.issue_transitioned";
    AuditAction["AGENT_GITHUB_COMMENT_ADDED"] = "agent.github.comment_added";
    AuditAction["AGENT_GMAIL_MESSAGE_SENT"] = "agent.gmail.message_sent";
    AuditAction["AGENT_GMAIL_DRAFT_CREATED"] = "agent.gmail.draft_created";
    AuditAction["AGENT_YANDEX_MAIL_MESSAGE_SENT"] = "agent.yandex_mail.message_sent";
    AuditAction["AGENT_YANDEX_MAIL_MESSAGE_REPLIED"] = "agent.yandex_mail.message_replied";
    AuditAction["AGENT_YANDEX_MAIL_DRAFT_CREATED"] = "agent.yandex_mail.draft_created";
    // Billing / admin
    AuditAction["BILLING_CREDITS_GRANTED"] = "billing.credits_granted";
    AuditAction["BILLING_TOP_UP_COMPLETED"] = "billing.top_up_completed";
    AuditAction["BILLING_REFUND_REQUESTED"] = "billing.refund_requested";
    AuditAction["BILLING_REFUND_RESOLVED"] = "billing.refund_resolved";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_PILOT_GRANTED"] = "billing.pilot_granted";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_PILOT_GRANT_DENIED"] = "billing.pilot_grant_denied";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_PLAN_UPGRADED"] = "billing.plan_upgraded";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_SUBSCRIPTION_CANCELED"] = "billing.subscription_canceled";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_DOWNGRADED_TO_FREE"] = "billing.downgraded_to_free";
    /** @deprecated Plans were removed (LP-272); kept for historical audit rows. */
    AuditAction["BILLING_TRIAL_EXPIRED"] = "billing.trial_expired";
    // Audit maintenance (sanctioned non-append paths)
    AuditAction["AUDIT_ACTOR_REDACTED"] = "audit.actor_redacted";
    AuditAction["AUDIT_RETENTION_PURGED"] = "audit.retention_purged";
})(AuditAction || (AuditAction = {}));
//# sourceMappingURL=audit-action.enum.js.map